import { ToggleButton as RACToggleButton, ToggleButtonProps, composeRenderProps } from 'react-aria-components'
import { tv, VariantProps } from 'tailwind-variants'
import { focusRing } from './utils'

const styles = tv({
  extend: focusRing,
  base: 'p-1 text-xs text-center uppercase flex flex-col items-center gap-1 transition rounded border border-white/10 dark:border-white/10 forced-colors:border-[ButtonBorder] cursor-default forced-color-adjust-none',
  variants: {
    fullWidth: {
      true: 'w-full',
      false: '',
    },
    variant: {
      contained: 'bg-baf-yellow hover:bg-baf-yellow-600 pressed:bg-baf-yellow-800 text-black',
      outlined:
        'text-baf-yellow bg-transparent border-baf-yellow hover:bg-baf-yellow-600/10 pressed:bg-baf-yellow-800/50 forced-colors:!bg-[Highlight] forced-colors:!text-[HighlightText]',
      inset:
        'border-none bg-baf-yellow-600/75 hover:bg-baf-yellow-800 pressed:bg-baf-yellow-800/50 text-black shadow-[inset_3px_3px_3px_0_rgba(94,70,7,1),inset_5px_5px_6px_0_rgba(130,96,8,0.75),inset_10px_10px_6px_0_rgba(150,116,8,0.75)]',
    },
    isSelected: { false: '', true: '' },
    isDisabled: {
      true: 'bg-gray-100 dark:bg-zinc-800 forced-colors:!bg-[ButtonFace] text-gray-300 dark:text-zinc-600 forced-colors:!text-[GrayText] border-black/5 dark:border-white/5 forced-colors:border-[GrayText]',
    },
  },
  defaultVariants: { variant: 'contained', fullWidth: false },
  compoundVariants: [
    {
      isSelected: false,
      variant: 'contained',
      class: 'bg-zinc-600 hover:bg-baf-yellow-600/50 pressed:bg-baf-yellow-800 text-white',
    },
    {
      isSelected: false,
      variant: 'outlined',
      class:
        'bg-zinc-500 border border-transparent border-white/20 hover:bg-zinc-400 pressed:bg-zinc-600 text-zinc-900 forced-colors:!bg-[ButtonFace] forced-colors:!text-[ButtonText]',
    },
    {
      isSelected: false,
      variant: 'inset',
      class:
        'shadow-[inset_-4px_-4px_5px_0_rgba(110,81,7,0.75),inset_-2px_-2px_2px_0_rgba(0,0,0,0.5),inset_3px_3px_5px_0_rgba(255,226,150,1),inset_2px_2px_2px_0_rgba(255,255,255,1)] bg-baf-yellow-200 hover:bg-baf-yellow-600 pressed:bg-baf-yellow-600/80',
    },
  ],
})

type ToggleButtonVariants = VariantProps<typeof styles>

export function ToggleButton({ variant, fullWidth, ...props }: ToggleButtonProps & ToggleButtonVariants) {
  return (
    <RACToggleButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        styles({ ...renderProps, variant, fullWidth, className })
      )}
    />
  )
}
